import { render, staticRenderFns } from "./WaterFallDefault.vue?vue&type=template&id=4bf6c5be&scoped=true"
import script from "./WaterFallDefault.vue?vue&type=script&lang=js"
export * from "./WaterFallDefault.vue?vue&type=script&lang=js"
import style0 from "./WaterFallDefault.vue?vue&type=style&index=0&id=4bf6c5be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6c5be",
  null
  
)

export default component.exports